// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1c-e";
export var animationRelative = "_1c-d";
export var backdropBlur = "_1c-0";
export var detailLabelCell = "_1c-q";
export var detailTable = "_1c-p";
export var detailValueCell = "_1c-r";
export var documentTypeIcon = "_1c-y";
export var documentTypeOption = "_1c-x";
export var dropdownMatchDatePicker = "_1c-3";
export var evidenceCardContent = "_1c-w";
export var gorgiasTicketCard = "_1c-s";
export var iconTertiary = "_1c-z";
export var integrationCard = "_1c-1";
export var integrationLogoBox = "_1c-2";
export var mainColumnSticky = "_1c-v";
export var maxWidthContainer = "_1c-t";
export var modalContentBody = "_1c-a";
export var modalHeaderImage = "_1c-5";
export var modalImageLabel = "_1c-7";
export var modalImageOverlay = "_1c-6";
export var modalImageSubtitle = "_1c-9";
export var modalImageTitle = "_1c-8";
export var modalImageWrapper = "_1c-4";
export var modalStickyFooter = "_1c-b";
export var sidebarColumn = "_1c-u";
export var timelineLine = "_1c-m";
export var timelineLineBlack = "_1c-o _1c-m";
export var timelineLineGray = "_1c-n _1c-m";
export var timelineLineHeight = "_1c-l";
export var tlDotActivate = "_1c-i";
export var tlDotActivateAnim = "_1c-h";
export var tlDotHide = "_1c-g";
export var tlDotHideAnim = "_1c-f";
export var tlLineActivate = "_1c-k";
export var tlLineActivateAnim = "_1c-j";
export var uploadedFileRow = "_1c-c";